<template lang="pug">
  div
    b-row
      //- .col-sm-12.col-md-12.col-lg-12.col-xl-12
      //-   h4.mb-1 #[b {{ $t("message.welcome_to_wbet") }}]
      .col-xl-3
        panel(:title='$t("ui.account")')
          .row.flex
            .col-sm-12.col-md-12.col-lg-12.col-xl-12
              .table-responsive
                table.table.table-sm.table-bordered
                  tbody
                    tr
                      th.width-xs(scope='row') {{ $t("ui.username")}}
                      td
                        span {{ $store.getters.accountID }}
                    tr
                      th(scope='row') {{ $t("ui.balance")}}
                      td
                        currency(:currency="userInfo.currency_code" v-if="userInfo")
                        span(:class="$helpers.getNumberClass(userInfo.cash_balance)" v-if="userInfo") {{ userInfo.cash_balance | currency }}
</template>

<script>
import currency from "@/components/settings/currency.vue"

export default {
  components: {
    currency
  },
  data() {
    return {
      userInfo: null,
    }
  },
  computed: {},
  // created: function() {
  //   this.pulling = setInterval(() => this.startOverview(), 1 * 30000);
  // },
  // beforeDestroy() {
  //   clearInterval(this.pulling);
  // },
  mounted: function(){
    this.startOverview()
    var swal_alert = localStorage.getItem("alert");
    if(swal_alert != 1){
      let status = this.$store.getters.accountStatus
      if(status == 'SUSPEND') {
        this.$swal({
          title: this.$t("ui.suspend"),
          text: this.$t("message.suspend_alert"),
          html: "<div>" + this.$t("message.suspend_alert1") + "</div>" +
                "<div>" + this.$t("message.suspend_alert2") + "</div>",
          type: "warning",
          allowOutsideClick: false
        })
      }
    }
    localStorage.setItem("alert", "1");
  },
  methods: {
    startOverview: function() {
      this.getDashboardInfo()
    },
    getDashboardInfo: function(){
      let account_id = this.$store.getters.accountID;
      this.$store
        .dispatch("user/getDashboardInfo", { account_id })
        .then(response => {
          if (response.success == true) {
            this.userInfo = response.data[0]
          }
        })
        .catch(response => {
        });
    }
  }
}
</script>
